import React from 'react'
// libs
import get from 'lodash/get'
import styled from 'styled-components'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import { ReduxInput } from 'components/FormElements/ReduxForm'
// view components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// constants
import { Forms } from 'constants/index'
// themes
import colors from 'themes/colors'
import { EllipsizedText } from 'themes/views/generic'
import { CloseIcon } from 'components/UI/Icons'
// types
import { LogEntityTypes } from 'types/graphql'

const Header = styled.div`
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  position: relative;
  height: 32px;
  border-bottom: 1px solid ${colors.blue500};
`

const Form = styled.form`
  margin: 15px;

  > p {
    margin: 15px 0 0 0;
    padding: 0;
    color: ${colors.gray300};
    font-size: small;
`

const Filename = styled(EllipsizedText)`
  background-color: ${colors.gray210};
  width: 100%;
`

interface IIncomingProps {
  hideModal: () => void
  activity: any
}

type IProps = IIncomingProps & InjectedFormProps<{}, IIncomingProps>

const EditActivityForm: React.FunctionComponent<IProps> = ({ hideModal, handleSubmit, activity }) => {
  const isImage: boolean = get(activity, 'entityType') === LogEntityTypes.Image
  const isLink: boolean = get(activity, 'entityType') === LogEntityTypes.Link
  const imageName: string = get(activity, 'metadata.fileName')

  return (
    <Form onSubmit={handleSubmit}>
      <Header>
        Edit {isImage ? 'Attachment' : 'Link'}
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      {isLink && (
        <>
          <p>Link target</p>
          <ReduxInput name={'linkTarget'} />
          <p>Link name</p>
          <ReduxInput name={'linkName'} />
        </>
      )}

      {isImage && (
        <>
          <p>Attachment name</p>
          <ReduxInput name={'attachmentName'} />
          <p>Filename</p>
          <Filename>{imageName}</Filename>
        </>
      )}
      <Button type={'submit'} layout={BUTTON_LAYOUTS.PURPLE} shadowLess style={{ borderRadius: 20, marginTop: 15 }}>
        Save
      </Button>
    </Form>
  )
}

export default reduxForm<any, any>({ form: Forms.EDIT_ACTIVITY_FORM })(EditActivityForm)
